import React, { Component } from 'react';
import compose from 'lodash/flowRight';
import { withSnackbar } from 'notistack';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import IconButton from '@material-ui/core/IconButton';

import { textInputStyle } from '../../themes/input';
import MHButton from '../MHButton';
import CoachSettingsRow from '../CoachSettingsRow';
import http from '../../services/Http';

const styles = (theme) => ({
  ...textInputStyle(theme),
});

class PasswordUpdate extends Component {
  state = {
    newPassword: '',
    confirmNewPassword: '',

    newPasswordDetailsLoading: false,
    showNewPassword: false,
    showConfirmPassword: false,
  };

  handleChange = (propertyToChange) => {
    return (event) => {
      // set the property
      this.setState({
        [propertyToChange]: event.target.value,
      });
    };
  };

  savePasswordDetails = async () => {
    const { currentUser } = this.props;
    const { newPassword, confirmNewPassword } = this.state;

    if (newPassword !== confirmNewPassword) {
      this.props.enqueueSnackbar('Passwords must match', { variant: 'error' });
      return;
    }

    try {
      this.setState({ newPasswordDetailsLoading: true });
      await http.formDataPATCH(`accounts/${currentUser.id}/`, { password: newPassword });
      this.props.enqueueSnackbar('Save success!', { variant: 'success' });
      this.props.closeDialog();
    } catch (error) {
      this.props.handleError(error);
    } finally {
      this.setState({ newPasswordDetailsLoading: false });
    }
  };

  handleClickShowNewPassword = async () => {
    this.setState({ showNewPassword: !this.state.showNewPassword });
  };

  handleClickShowConfirmPassword = async () => {
    this.setState({ showConfirmPassword: !this.state.showConfirmPassword });
  };

  get passwordDetailsDisabled() {
    const { newPassword, confirmNewPassword } = this.state;

    return !newPassword.length || !confirmNewPassword.length;
  }

  render() {
    const { classes, closeDialog } = this.props;
    const {
      newPassword,
      confirmNewPassword,
      newPasswordDetailsLoading,
      showNewPassword,
      showConfirmPassword,
    } = this.state;
    return (
      <Dialog open onClose={closeDialog} aria-labelledby="form-dialog-title" fullWidth>
        <DialogTitle id="form-dialog-title">Change Password</DialogTitle>
        <DialogContent>
          <CoachSettingsRow title="New Password">
            <TextField
              margin="dense"
              variant="outlined"
              value={newPassword}
              onChange={this.handleChange('newPassword')}
              className={classes.textField}
              InputProps={{
                className: classes.textFieldInput,
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="Toggle password visibility"
                      onClick={this.handleClickShowNewPassword}
                    >
                      {showNewPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              type={showNewPassword ? 'text' : 'password'}
            />
          </CoachSettingsRow>

          <CoachSettingsRow title="Confirm New Password">
            <TextField
              margin="dense"
              variant="outlined"
              value={confirmNewPassword}
              onChange={this.handleChange('confirmNewPassword')}
              className={classes.textField}
              InputProps={{
                className: classes.textFieldInput,
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="Toggle password visibility"
                      onClick={this.handleClickShowConfirmPassword}
                    >
                      {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              type={showConfirmPassword ? 'text' : 'password'}
            />
          </CoachSettingsRow>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeDialog} color="primary">
            Cancel
          </Button>
          <MHButton
            children="Update"
            onClick={this.savePasswordDetails}
            disabled={this.passwordDetailsDisabled}
            loading={newPasswordDetailsLoading}
          />
        </DialogActions>
      </Dialog>
    );
  }
}

export default compose(withStyles(styles), withSnackbar)(PasswordUpdate);
